import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo, GreenDivider } from '../components/FeaturedSolutions';

function AreaDetailPage({ config, sectionHeader }) {
  const navigate = useNavigate();
  const { pageClass, mapBg, title, text, solutions, hasBackground, imgFirst } = config;

  return (
    <div className={`page ${pageClass}`} style={mapBg && !hasBackground ? { backgroundImage: `url(${mapBg})`, backgroundSize: 'cover', backgroundPosition: '50% 50%', backgroundRepeat: 'no-repeat' } : {}}>
      {hasBackground && <div className="background" style={{ backgroundImage: `url(${mapBg})`, backgroundSize: 'cover', backgroundPosition: '50% 50%', backgroundRepeat: 'no-repeat', height: '100%', width: '100%', position: 'absolute', top: 0, left: 0 }} />}
      <div className="page-header">{sectionHeader}</div>
      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">{title}</div>
          <GreenDivider />
        </div>
        <div className="std-text">{text}</div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            {imgFirst ? (
              <>
                <img src={sol.screenshot} alt={sol.name} />
                <div className="item-head"><AgilysysLogo />{sol.name}</div>
              </>
            ) : (
              <>
                <div className="item-head"><AgilysysLogo />{sol.name}</div>
                <img src={sol.screenshot} alt={sol.name} />
              </>
            )}
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default AreaDetailPage;
